module.exports = __webpack_public_path__ + "public/img/no-data.49ee49b6.png";